//数据曝光组件
class Exposure {
  constructor(callback) {
    if (!callback || typeof callback !== 'function') {
      throw new Error('need callback or selector param');
    }
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((item) => {
        if (item.intersectionRatio > 0) {
          if (item.target) {
            callback(item.target, item);
            this.intersectionObserver.unobserve(item.target);
          }
        }
      });
    });
  }

  observe(selector, ignoreExposured) {
    if (!this.intersectionObserver || !selector) {
      return;
    }
    let nodes = [];
    if (this.isDOM(selector)) {
      // dom节点
      nodes = [selector];
    } else {
      // 选择器
      nodes = document.querySelectorAll(selector);
    }
    if (!nodes.length) {
      return;
    }
    nodes.forEach((node) => {
      if (!ignoreExposured && node.__wg__tracker__exposured__) {
        return;
      }
      node.__wg__tracker__exposured__ = true;
      // 开始观察
      this.intersectionObserver.observe(node);
    });
  }

  disconnect() {
    if (!this.intersectionObserver) {
      return;
    }
    this.intersectionObserver.disconnect();
  }

  isDOM(obj) {
    if (!obj) {
      return false;
    }
    if (typeof HTMLElement === 'object') {
      return obj instanceof HTMLElement;
    }
    if (
      typeof obj === 'object' &&
      obj.nodeType === 1 &&
      typeof obj.nodeName === 'string'
    ) {
      return true;
    }
    return false;
  }
}

export default Exposure;
